<ng-container *ngIf="amtDetails && amtDetails.dispalyStr">
  {{amtDetails.dispalyStr}}
</ng-container>
